/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomCertSchema
 */
export interface CustomCertSchema {
    /**
     * 
     * @type {string}
     * @memberof CustomCertSchema
     */
    subdomain: string;
}

/**
 * Check if a given object implements the CustomCertSchema interface.
 */
export function instanceOfCustomCertSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "subdomain" in value;

    return isInstance;
}

export function CustomCertSchemaFromJSON(json: any): CustomCertSchema {
    return CustomCertSchemaFromJSONTyped(json, false);
}

export function CustomCertSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomCertSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subdomain': json['subdomain'],
    };
}

export function CustomCertSchemaToJSON(value?: CustomCertSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subdomain': value.subdomain,
    };
}

